/**
 * ExecutionLogs Component
 *
 * 전략 실행 로그 테이블
 */

import React from 'react';
import type { ExecutionLog } from '../types/strategy';
import TimeDisplay from './TimeDisplay';

interface ExecutionLogsProps {
  logs: ExecutionLog[];
}

const ExecutionLogs: React.FC<ExecutionLogsProps> = ({ logs }) => {
  return (
    <div className="execution-logs">
      <h3>실행 로그 (전략 실행 완료 시 자동 갱신)</h3>
      {logs.length === 0 ? (
        <div className="empty">실행 로그가 없습니다</div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>시간</th>
                <th>종목</th>
                <th>액션</th>
                <th>결과</th>
                <th>사유</th>
                <th>수량</th>
                <th>가격</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>
                    <TimeDisplay utcTime={log.executed_at} />
                  </td>
                  <td>{log.symbol}</td>
                  <td className={`action ${log.action.toLowerCase()}`}>{log.action}</td>
                  <td className={log.executed ? 'executed' : 'not-executed'}>
                    {log.executed ? '실행' : '미실행'}
                  </td>
                  <td className="reason">{log.reason}</td>
                  <td>{log.quantity ? log.quantity.toFixed(2) : '-'}</td>
                  <td>{log.price ? `$${log.price.toFixed(2)}` : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExecutionLogs;
